module.exports = __webpack_public_path__ + "static/image_03@2x-4ed7ea536b1dcb8ed3833fe655544f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/trusona/image_03@2x.jpg
// module id = 420
// module chunks = 3627797113349 20562973939449 33019919093843